import React from "react";
import { SeoHelper } from "./SeoHelper";

export default function SeoNoIndex({ uri, description }) {
    return (
        <SeoHelper
            uri={uri}
            description={description}
            robots="noindex, nofollow"
        />
    );
}